/* Tysk katalog for locale-payroll-employees-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'pay.personalia': 'Personalien',
  'pay.personalInfo': 'Persönliche Angaben',
  'pay.edit': 'Bearbeiten',
  'pay.documents': 'Dokumente',
  'pay.description': 'Beschreibung',
  'pay.contract': 'Arbeitsvertrag',
  'pay.open': 'Öffnen',
  'pay.download': 'Herunterladen',
  'pay.delete': 'Löschen',
  'pay.employment': 'Arbeitsverhältnis',
  'pay.positionAndAgreement': 'Stelle und Vereinbarung',
  'pay.searchOccupationCodes': 'Berufscodes durchsuchen ...',
  'pay.cancel': 'Abbrechen',
  'pay.saveEmployment': 'Arbeitsverhältnis speichern',
  'pay.employmentFrom': 'Arbeitsverhältnis gilt ab',
  'pay.employmentFromHint': 'Das Datum, an dem der Mitarbeiter seinen ersten Arbeitstag in deinem Unternehmen hatte oder haben wird. Dieses Datum ist unabhängig davon, wann du mit der Buchhaltung in Plumme begonnen hast.',
  'pay.endDate': 'Enddatum',
  'pay.endDateHint': 'Lass das Feld leer, solange das Arbeitsverhältnis noch besteht.',
  'pay.occupationCode': 'Berufscode',
  'pay.occupationCodeHint': 'Durchsuche das öffentliche Register der Berufscodes und wähle den passendsten. Das Feld wird für die Berufsstatistik in Norwegen verwendet.',
  'pay.employmentType': 'Art des Arbeitsverhältnisses',
  'pay.employmentForm': 'Beschäftigungsform',
  'pay.workingHoursScheme': 'Arbeitszeitregelung',
  'pay.workingHoursSchemeHint': 'Die meisten Mitarbeiter fallen unter „Keine Schicht“, einige aber auch unter die anderen Kategorien.',
  'pay.hoursFullWeek': 'Stunden für eine volle Woche',
  'pay.salaryType': 'Lohnart',
  'pay.hourlyPay': 'Stundenlohn',
  'pay.fixedPay': 'Festgehalt',
  'pay.ftePercent': 'Stellenanteil',
  'pay.ftePercentHint': 'Wähle einen geschätzten Stellenanteil. Wenn du unsicher bist, nimm den nächstliegenden Prozentsatz.',
  'pay.fullTime': 'Vollzeit',
  'pay.partTime': 'Teilzeit',
  'pay.employmentScope': 'Beschäftigungsumfang',
  'pay.adjustHoursBy': 'Stunden anpassen nach',
  'pay.perWeek': 'Pro Woche',
  'pay.perMonth': 'Pro Monat',
  'pay.hoursPerWeek': 'Stunden pro Woche',
  'pay.hoursPerMonth': 'Stunden pro Monat',
  'pay.otherEntityNumber': 'Andere Betriebsnummer',
  'pay.optionalEntityNumber': 'Optionale Betriebsnummer',
  'pay.priorPayOutsidePlumme': 'Früherer Lohn außerhalb von Plumme, von deinem Unternehmen ausgezahlt',
  'pay.priorPayHelp': 'Trage nur Lohn ein, der nicht in Plumme erfasst ist, aber vom Unternehmen ausgezahlt wurde.',
  'pay.warning': 'Warnung:',
  'pay.forPublicStatistics': 'Für die öffentliche Statistik - nur ausfüllen, wenn relevant',
  'pay.lastAdjustmentDate': 'Datum der letzten Lohnanpassung',
  'pay.salaryGrade': 'Gehaltsstufe',
  'pay.salaryGradePh': 'Z. B. 45',
  'pay.agreedSalary': 'Vereinbarter Lohn',
  'pay.save': 'Speichern',
  'pay.annualSalary': 'Jahreslohn',
  'pay.agreementTaxHeading': 'Vereinbarung, Urlaubsgeld, Steuer und Arbeitgeberabgabe',
  'pay.tax': 'Steuer',
  'pay.notFetchedFromAltinn': 'Nicht aus Altinn abgerufen',
  'pay.salaryPerYear': 'Lohn pro Jahr',
  'pay.holidayPay': 'Urlaubsgeld',
  'pay.employerContribution': 'Arbeitgeberabgabe',
  'pay.estimatedTax': 'Geschätzte Steuer',
  'pay.estimatedAnnualCost': 'Geschätzte Jahreskosten',
  'pay.noAgreedSalary': 'Es ist kein vereinbarter Lohn eingetragen',
  'pay.taxCard': 'Steuerkarte',
  'pay.taxCardHelp': 'Steuerkarten werden noch nicht abgerufen. Das wird angebunden, sobald die Integration mit Skatteetaten bereit ist.',
  'pay.fixedLines': 'Feste Zeilen',
  'pay.fixedLinesHelp': 'Lohnzeilen, die normalerweise in jeder Lohnzahlung enthalten sind.',
  'pay.newFixedLine': 'Neue feste Zeile erstellen',
  'pay.seeFixedLines': 'Feste Lohnzeilen ansehen',
  'pay.payslips': 'Lohnabrechnungen',
  'pay.noPayslips': 'Es wurden noch keine Lohnabrechnungen erstellt.',
  'pay.gross': 'Brutto',
  'pay.paidOut': 'Ausgezahlt',
  'pay.employeePortal': 'Mitarbeiterportal',
  'pay.employeePortalSub': 'Lohnabrechnungen, Reisen und Auslagen für den Mitarbeiter.',
  'pay.needEmailFirst': 'Trage im Mitarbeiterprofil eine gültige E-Mail-Adresse ein, bevor du Zugriff gewährst.',
  'pay.goToTravelExpenses': 'Zu Reisen und Auslagen',
  'pay.saveEmployee': 'Mitarbeiter speichern',
  'pay.nationalId': 'Personennummer',
  'pay.hasInternationalId': 'Hat eine internationale ID',
  'pay.name': 'Name',
  'pay.phone': 'Telefonnummer',
  'pay.email': 'E-Mail',
  'pay.address': 'Adresse',
  'pay.country': 'Land',
  'pay.address1': 'Adresse 1',
  'pay.streetAddress': 'Straße und Hausnummer',
  'pay.address2': 'Adresse 2',
  'pay.optional': 'Optional',
  'pay.postalCode': 'Postleitzahl',
  'pay.postalPlace': 'Ort',
  'pay.postalPlacePh': 'Ort ...',
  'pay.accountNumber': 'Kontonummer',
  'pay.hasForeignAccount': 'Hat eine ausländische Kontonummer',
  'pay.mainOrSecondaryEmployer': 'Neben-/Hauptarbeitgeber',
  'pay.taxAndDutyRules': 'Steuer- und Abgaberegeln',
  'pay.noteOptional': 'Notiz (optional)',
  'pay.notePh': 'Notiz schreiben ...',
  'pay.employees': 'Mitarbeiter',
  'pay.employeesHelp': 'Das Verzeichnis aller Mitarbeiter des Unternehmens. Tippe auf einen Mitarbeiter, um Personalien, Arbeitsverhältnis, Lohn und Lohnabrechnungen zu sehen.',
  'pay.allEmployees': 'Alle Mitarbeiter in deinem Unternehmen',
  'pay.newEmployee': 'Neuer Mitarbeiter',
  'pay.newEmployeeHelp': 'Erfasse einen neuen Mitarbeiter mit Personalien, Arbeitsverhältnis und Lohnbedingungen. Der Mitarbeiter wird dann in Lohnläufe und die A-melding einbezogen.',
  'pay.noEmployees': 'Noch keine Mitarbeiter',
  'pay.salaryTypeLabel': 'Lohnart:',
  'pay.status': 'Status',
  'pay.statusHelp': 'Ein aktives Arbeitsverhältnis bedeutet, dass der Mitarbeiter in Lohnläufe einbezogen wird. Beendet bedeutet, dass das Arbeitsverhältnis aufgelöst ist.',
  'pay.payroll': 'Lohn',
  'pay.payrollSub': 'Lohn abrechnen, Mitarbeiter betreuen, Zeiträume und Urlaubsgeld verwalten.',
  'pay.payrollModuleHelp': 'Das Lohnmodul bündelt alles zu Mitarbeitern und Lohn: Lohnabrechnung, Arbeitgeberabgabe und Lohnsteuerabzug, Rente (OTP), Urlaubsgeld, Reisen und Auslagen sowie Einstellungen. Wechsle über das Dropdown-Menü zwischen den Unterseiten.',
  'pay.payrollPages': 'Lohnseiten',
  'pay.payrollPagesHelp': 'Wechsle zwischen den Unterseiten von Lohn — Mitarbeiter, Lohnauszahlung, Arbeitgeberabgabe und Steuer, Rente/OTP, Feste Lohnzeilen, Reisen und Auslagen, Lohnübersicht, Urlaubsgeldliste, Lohneinstellungen und Lohnarten.',
  'pay.employmentStatus': 'Beschäftigungsstatus',
  'pay.employmentStatusHelp': 'Zeigt, ob das Arbeitsverhältnis aktiv oder beendet ist. Aktive Mitarbeiter werden in Lohnläufe einbezogen und in der A-melding gemeldet.',
  'pay.backToPayrollRun': 'Zurück zur Lohnauszahlung',
  'pay.showAllEmployees': 'Alle Mitarbeiter anzeigen',
  'pay.yourEmployers': 'Deine Arbeitgeber',
  'pay.yourClients': 'Deine Mandanten',
  'pay.bgForEmployer': 'Hintergrundfarbe für diesen Arbeitgeber',
  'pay.bgColour': 'Hintergrundfarbe',
  'pay.receiptHelp': 'Foto aufnehmen, hochladen, hineinziehen oder einfügen. Auslagen ohne Beleg können nicht eingereicht werden.',
  'pay.takePhoto': 'Foto aufnehmen',
  'pay.uploadFile': 'Bild/Datei hochladen',
  'pay.remove': 'Entfernen',
  'pay.registerExpense': 'Auslage erfassen',
  'pay.receiptRequired': 'Beleg erforderlich',
  'pay.category': 'Kategorie',
  'pay.pickCategory': 'Kategorie wählen',
  'pay.date': 'Datum',
  'pay.paidWith': 'Bezahlt mit',
  'pay.privateExpense': 'Private Auslage',
  'pay.companyCard': 'Firmenkarte/Geschäftskonto',
  'pay.amount': 'Betrag',
  'pay.currency': 'Währung',
  'pay.whatIsExpenseFor': 'Wofür ist die Auslage?',
  'pay.registerTravel': 'Reise erfassen',
  'pay.sentForApproval': 'Wird zur Genehmigung gesendet',
  'pay.dateFrom': 'Datum von',
  'pay.dateTo': 'Datum bis',
  'pay.travelType': 'Reiseart',
  'pay.travelWithExpenses': 'Reise mit Auslagen/Fahrten',
  'pay.drivingOnly': 'Nur Fahrt',
  'pay.travelWithSubsistence': 'Reise mit Verpflegungspauschale',
  'pay.destination': 'Reiseziel',
  'pay.destinationPh': 'Stadt, Kunde oder Ort',
  'pay.from': 'Von',
  'pay.startPlace': 'Startort',
  'pay.to': 'Nach',
  'pay.endPlace': 'Zielort',
  'pay.kilometres': 'Kilometer',
  'pay.purpose': 'Zweck',
  'pay.purposeHelp': 'Was war der Zweck der Reise?',
  'pay.note': 'Notiz',
  'pay.createTravelClaim': 'Reisekostenabrechnung erstellen',
  'pay.purposePh': 'Z. B. Kundentermin in Drammen',
  'pay.whereDidYouGo': 'Wohin ging die Reise?',
  'pay.norway': 'Norwegen',
  'pay.tolls': 'Mautgebühren',
  'pay.tollsPaidWith': 'Maut bezahlt mit',
  'pay.fromDate': 'Ab Datum',
  'pay.toDate': 'Bis Datum',
  'pay.type': 'Typ',
  'pay.hotel': 'Hotel',
  'pay.otherAccommodation': 'Andere Unterkunft',
  'pay.guesthouse': 'Pension oder Baracke',
  'pay.place': 'Ort',
  'pay.hotelOrPlace': 'Hotel oder Ort',
  'pay.travelClaim': 'Reisekostenabrechnung',
  'pay.rejectedByEmployer': 'Vom Arbeitgeber abgelehnt',
  'pay.newAccommodation': 'Neue Übernachtung',
  'pay.newTrip': 'Neue Fahrt',
  'pay.newExpense': 'Neue Auslage',
  'pay.noLinesYet': 'Noch keine Zeilen',
  'pay.employee': 'Mitarbeiter',
  'pay.subsistence': 'Verpflegungspauschale',
  'pay.payslip': 'Lohnabrechnung',
  'pay.close': 'Schließen',
  'pay.netPaid': 'Netto ausgezahlt',
  'pay.period': 'Zeitraum',
  'pay.payAndDeductions': 'Lohn und Abzüge',
  'pay.grossPay': 'Bruttolohn',
  'pay.withholdingTax': 'Lohnsteuerabzug',
  'pay.expenseRefund': 'Erstattung Auslagen/Reise',
  'pay.payslipPdfNote': 'PDF-Ansicht und Versand werden angebunden, sobald der Lohnabrechnungsgenerator in Plumme verfügbar ist.',
  'pay.noPayslipsYet': 'Noch keine Lohnabrechnungen.',
  'pay.myExpenses': 'Meine Auslagen',
  'pay.noExpensesInView': 'Keine Auslagen in dieser Ansicht.',
  'pay.expenses': 'Auslagen',
  'pay.preview': 'Vorschau',
  'pay.loadingReceipt': 'Beleg wird geladen...',
  'pay.canStillDownload': 'Der Beleg kann weiterhin manuell heruntergeladen werden.',
  'pay.cannotPreview': 'Dieser Dateityp kann hier nicht in der Vorschau angezeigt werden.',
  'pay.openNewTab': 'In neuem Tab öffnen',
  'pay.myTravel': 'Meine Reisen',
  'pay.noTravelInView': 'Keine Reisen in dieser Ansicht.',
  'pay.fetchingPortal': 'Mitarbeiterportal wird geladen',
  'pay.portalFailed': 'Mitarbeiterportal konnte nicht geladen werden',
  'pay.back': 'Zurück',
  'pay.noEmployers': 'Keine Arbeitgeber',
  'pay.home': 'Start',
  'pay.homeHelp': 'Deine Mitarbeiterseite beim gewählten Arbeitgeber — Lohnabrechnungen, Auslagen und Reisen.',
  'pay.myPage': 'Meine Seite',
  'pay.myPageHelp': 'Dein persönliches Konto in Plumme — Profil, Unternehmen und Privatfinanzen.',
  'pay.signOut': 'Abmelden',
  'pay.paidByCompanyHint': 'Der Beleg geht in die Buchhaltung, nicht in die Erstattung.',
  'pay.paidPrivateHint': 'Du bekommst den Betrag mit dem Lohn erstattet.',
  'pay.expenseProject': 'Projekt',
  'pay.expenseProjectHint': 'Auslagen für ein Projekt können an den Kunden weiterberechnet werden.',
  'pay.expenseNoProject': 'Kein Projekt',
  'pay.myHours': 'Meine Stunden',
  'pay.hoursThisMonth': '{time} in diesem Monat',
  'pay.hoursHelp': 'Die Stunden, die du für diesen Arbeitgeber auf Projekte gebucht hast.',
  'pay.registerHours': 'Stunden erfassen',
  'pay.timeNew': 'Stunden erfassen',
  'pay.timeEdit': 'Eintrag bearbeiten',
  'pay.timeDate': 'Datum',
  'pay.timeProject': 'Projekt',
  'pay.timeActivity': 'Tätigkeit',
  'pay.timeHours': 'Stunden',
  'pay.timeNote': 'Notiz',
  'pay.timeNotePh': 'Woran hast du gearbeitet?',
  'pay.timePickProject': 'Projekt wählen …',
  'pay.timePickActivity': 'Tätigkeit wählen …',
  'pay.timeSum': 'Summe',
  'pay.timeSaved': 'Der Eintrag wurde gespeichert',
  'pay.timeDeleted': 'Der Eintrag wurde gelöscht',
  'pay.timeFailed': 'Der Eintrag konnte nicht gespeichert werden.',
  'pay.timeLocked': 'Die Zeiterfassung für diesen Zeitraum ist als abgeschlossen markiert.',
  'pay.timeLockedThrough': 'Die Zeiterfassung ist bis einschließlich {date} als abgeschlossen markiert.',
  'pay.timeEmptyTitle': 'Keine Stunden in dieser Woche',
  'pay.timeEmpty': 'Tippe auf „Stunden erfassen“, um den ersten Eintrag anzulegen.',
  'pay.timeNoProjectsTitle': 'Keine Projekte',
  'pay.timeNoProjects': 'Dein Arbeitgeber hat noch keine Projekte angelegt, auf die du Stunden buchen kannst.',
  'pay.timePrevWeek': 'Vorherige Woche',
  'pay.timeNextWeek': 'Nächste Woche',
  'pay.myEmployeePage': 'Meine Mitarbeiterseite',
  'pay.myEmployeePageHelp': 'Deine Seite als Mitarbeitende/r bei einem Arbeitgeber — getrennt von einer eventuellen Buchhaltung, die du führst. Hier siehst du deine Lohnabrechnungen und erfasst Auslagen und Reisen, die dir erstattet werden sollen. Oben wechselst du zwischen den Arbeitgebern, bei denen du angestellt bist.',
  'pay.employer': 'Arbeitgeber',
  'pay.employerHelp': 'Der Arbeitgeber, auf den sich diese Seite bezieht. Bist du an mehreren Stellen angestellt, wechselst du hier — dann zeigen Lohnabrechnungen, Auslagen und Reisen die Zahlen des gewählten Arbeitgebers.',
  'pay.payslipsHelp': 'Die Lohnabrechnungen des Arbeitgebers — eine Übersicht über Lohn, Steuerabzug und ausgezahlten Betrag für jeden Lohnlauf. Tippe zum Öffnen.',
  'pay.expensesHelp': 'Auslagen, die du aus eigener Tasche bezahlt hast und erstattet bekommen sollst — z. B. eine privat bezahlte Quittung. Reiche sie zur Genehmigung ein, dann werden sie über den Lohn erstattet.',
  'pay.travelHelp': 'Reisekostenabrechnungen mit Kilometergeld, Verpflegungspauschale und Auslagen zu einer Reise. Reiche sie zur Genehmigung und Erstattung über den Lohn ein.',
  'pay.registerExpenseHelp': 'Erfasse eine neue Auslage — lade die Quittung hoch, gib den Betrag und den Zweck an. Sie wird dem Arbeitgeber zur Genehmigung und Erstattung gesendet.',
  'pay.registerTravelHelp': 'Erfasse eine Reisekostenabrechnung — Fahrten (Kilometergeld), Verpflegungspauschale und Auslagen zur Reise. Sie wird dem Arbeitgeber zur Genehmigung gesendet.',
  'pay.employmentStatusLabel.active': 'Aktives Arbeitsverhältnis',
  'pay.employmentStatusLabel.ended': 'Ausgeschieden',
  'pay.employmentStatusLabel.future': 'Beginnt später',
  'pay.taxRuleNotSupported': 'wird noch nicht unterstützt',
  'pay.taxRuleNotSupportedHint': 'Plumme berechnet nur die ordentliche Steuer und Arbeitgeberabgabe. Ein Lohnlauf mit diesem Mitarbeitenden kann nicht genehmigt werden – führe die Lohnabrechnung für diese Person außerhalb von Plumme durch.',
  'pay.portalEmploymentEnded': 'Dein Arbeitsverhältnis ist beendet. Du kannst deine Lohnabrechnungen weiterhin sehen, aber keine neuen Auslagen, Reisen oder Stunden einreichen. Wende dich an deinen Arbeitgeber, wenn du eine Auslage erstattet bekommen sollst.',
  'err.employeePortal.employmentEnded': 'Das Arbeitsverhältnis ist beendet, und das Mitarbeiterportal ist jetzt nur noch lesbar. Bitte den Arbeitgeber, die Auslage zu erfassen.',
  'pay.foreignAmount.label': 'In NOK bezahlter Betrag',
  'pay.foreignAmount.hint': 'Die Quittung ist in {currency}. Gib an, was du tatsächlich in norwegischen Kronen bezahlt hast, zum Beispiel laut Kontoauszug. Die Auslage kann ohne NOK-Betrag nicht genehmigt werden.',
  'pay.foreignAmount.rateHint': 'Entspricht einem Kurs von {rate} NOK pro {currency}.',
  'pay.foreignAmount.missing': 'NOK-Betrag fehlt',
  'pay.foreignAmount.missingOnApproval': 'Die Auslage „{description}“ ist in {currency} und hat keinen NOK-Betrag. Bearbeite die Zeile und gib den tatsächlich in NOK bezahlten Betrag ein, bevor du genehmigst.',
  'err.payroll.foreignAmountMissingNok': 'Einer Auslage in Fremdwährung fehlt der NOK-Betrag. Gib den tatsächlich in NOK bezahlten Betrag ein, bevor du genehmigst.',
  'pay.tabSalaryTax': 'Lohn & Steuern',
  'pay.tabPayslipsExpenses': 'Lohnabrechnungen & Auslagen',
  'pay.taxRuleOption.ordinary': 'Ordentlich',
  'pay.taxRuleOption.svalbard': 'Svalbard',
  'pay.taxRuleOption.janMayen': 'Jan Mayen und Nebengebiete',
  'pay.taxRuleOption.seafarerDeduction': 'Sonderabzug für Seeleute',
  'pay.taxRuleOption.charity': 'Wohltätige oder gemeinnützige Organisation',
  'pay.taxRuleOption.netPay': 'Nettolohn',
  'pay.taxRuleOption.netPaySeafarer': 'Nettolohn für Seeleute',
  'pay.taxRuleOption.pensionSourceTax': 'Quellensteuer auf Renten',
  'pay.taxRuleOption.nanny': 'Tagesmutter im Haushalt des Kindes',
  'pay.taxRuleOption.homeWork': 'Lohnarbeit im Privathaushalt',
  'pay.taxRuleOption.taxFreeOrg': 'Steuerbefreite Organisation',
  'pay.employmentTypeOption.ordinary': 'Ordentliches Arbeitsverhältnis',
  'pay.employmentTypeOption.maritime': 'Maritimes Arbeitsverhältnis',
  'pay.employmentTypeOption.freelance': 'Freiberufler, Auftragnehmer oder Honorarempfänger',
  'pay.employmentTypeOption.pension': 'Rente oder anderes abzugspflichtiges Verhältnis',
  'pay.employmentTypeOption.notEmployed': 'Nicht angestellt',
  'pay.employmentTypeOption.simplifiedPrivate': 'Vereinfachtes Abrechnungsverfahren, privater Arbeitgeber',
  'pay.employmentTypeOption.simplifiedCharity': 'Vereinfachtes Abrechnungsverfahren, wohltätige Organisation',
  'pay.employmentTypeOption.foreignService': 'Ausländisches Dienstverhältnis',
  'pay.employmentTypeOption.boardFee': 'Vorstandsvergütung',
  'pay.employmentFormOption.permanent': 'Unbefristet',
  'pay.employmentFormOption.temporary': 'Befristet',
  'pay.employmentFormOption.temporarySubstitute': 'Befristet als Aushilfe auf Abruf',
  'pay.employmentFormOption.permanentHiredOut': 'Unbefristet und überlassen',
  'pay.employmentFormOption.temporaryHiredOut': 'Befristet und überlassen',
  'pay.shift.offshore': 'Offshore',
  'pay.hourlyOvertimePay': 'Stundenlohn - Überstunden',
  'pay.fixedLine': 'Feste Zeile',
  'pay.portalAccess.notInvited': 'Kein Zugang gewährt',
  'pay.portalAccess.active': 'Aktiver Zugang',
  'pay.portalAccess.revoked': 'Zugang entzogen',
  'pay.documentUploaded': 'Dokument hochgeladen.',
  'pay.documentsUploaded': 'Dokumente hochgeladen.',
  'pay.documentDeleted': 'Dokument gelöscht.',
  'pay.amountRequired': 'Gib einen Betrag ein.',
  'pay.fixedLineDeleted': 'Feste Lohnzeile gelöscht.',
  'pay.fixedLineDeleteFailed': 'Feste Lohnzeile konnte nicht gelöscht werden.',
  'pay.emailRequiredFirst': 'Gib zuerst eine gültige E-Mail-Adresse im Mitarbeiterprofil ein.',
  'pay.portalAccessSent': 'Zugang an {email} gesendet.',
  'pay.portalAccessRevokedToast': 'Zugang entzogen.',
  'pay.portalAccessSendFailed': 'Zugang konnte nicht gesendet werden.',
  'pay.portalAccessRevokeFailed': 'Zugang konnte nicht entzogen werden.',
  'pay.saveEmployeeFailed': 'Mitarbeitende/r konnte nicht gespeichert werden.',
  'pay.confirmDeleteDocument': 'Dokument „{name}“ löschen?',
  'pay.confirmDeleteFixedLine': 'Feste Lohnzeile „{line}“ für {name} löschen?',
  'pay.confirmRevokePortalAccess': 'Mitarbeiterportal-Zugang für {name} entziehen?',
  'pay.taxCardValidUntil': 'Steuerkarte gültig bis',
  'pay.leaveOfAbsence': 'Beurlaubungen',
  'pay.noLeaveRegistered': 'Keine erfasst',
  'pay.loginEmail': 'E-Mail für die Anmeldung',
  'pay.lastSent': 'Zuletzt gesendet',
  'pay.revoked': 'Entzogen',
  'pay.bankAccount': 'Bankkonto',
  'pay.hoursInFullWeek': 'Stunden in einer vollen Woche',
  'pay.uploading': 'Wird hochgeladen ...',
  'pay.newDocument': 'Neues Dokument',
  'pay.resendAccess': 'Zugang erneut senden',
  'pay.grantEmployeeAccess': 'Mitarbeitenden Zugang gewähren',
  'pay.revoking': 'Wird entzogen ...',
  'pay.revokeAccess': 'Zugang entziehen',
  'pay.portalAccessExplain': 'Der Zugang ist mit der E-Mail-Adresse und der Mitarbeiter-ID verknüpft. Die Mitarbeiteroberfläche nutzt diese Verknüpfung, sobald die Portalanmeldung angebunden ist.',
  'pay.useStandardHolidayRate': 'Standardsatz aus den Lohneinstellungen verwenden ({rate} %)',
  'pay.priorYearSalaryHeading': 'Lohn in {year}',
  'pay.payrollDataHidden': 'Lohndaten sind für diesen Zugriff ausgeblendet',
  'pay.payrollDataHiddenBody': 'Mitarbeitende, feste Lohnzeilen und Lohnauszahlungen liegen in einem eigenen Personaldokument. Deine Rolle bei diesem Mandanten ist {role}, und die App konnte das Personaldokument nicht lesen. Reisen und Auslagen, die in der Buchhaltung gebucht sind, können daher weiterhin angezeigt werden.',
  'pay.unknownAccess': 'unbekannter Zugriff',
  'pay.readAccess': 'Lesezugriff',
  'pay.registerFirstEmployee': 'Erfasse den ersten Mitarbeitenden, um Lohnläufe, Steuerkarten und die A-melding zu nutzen.',
  'pay.mainEmployerOption': 'Hauptarbeitgeber',
  'pay.secondaryEmployerOption': 'Nebenarbeitgeber',
  'pay.documentsCount': '{count} Dokumente',
  'pay.noDocumentsUploaded': 'Keine hochgeladenen Dokumente',
  'pay.cannotOpenDocument': 'Dokument konnte nicht geöffnet werden.',
  'pay.cannotDownloadDocument': 'Dokument konnte nicht heruntergeladen werden.',
  'pay.endEmployment': 'Arbeitsverhältnis beenden',
  'pay.reopenEmployment': 'Arbeitsverhältnis wieder öffnen',
  'pay.earnedHolidayPayInYear': 'Erworbenes Urlaubsgeld in {year}',
  'pay.holidayPayNotPaidBeforeStartHint': 'Urlaubsgeld, das vor dem Startdatum in Plumme nicht ausgezahlt wurde.',
  'pay.earnedTaxablePayInYear': 'Erworbener Lohn (Steuergrundlage) in {year}',
  'pay.grossPayNotInPlummeHint': 'Bruttolohn, den das Unternehmen in {year} ausgezahlt hat und der nicht in Plumme erfasst ist.',
  'pay.withheldTaxInYear': 'Einbehaltene Steuer in {year}',
  'pay.priorYearAmountWarning': 'Beträge für {year} nur ausfüllen, wenn sie nicht in anderen in Plumme erfassten Lohnauszahlungen enthalten sind.',
  'pay.agreedSalaryInternalNote': 'Der vereinbarte Lohn dient nur der internen Dokumentation. Lohnläufe werden über feste oder manuelle Lohnzeilen gesteuert.',
  'pay.estimatedAnnualSalaryFrom': 'Der geschätzte Jahreslohn wird berechnet aus {summary}',
  'pay.fixedLinesRegisteredCount': '{count} erfasst',
  'pay.fixedLinesOnEmployee': 'Feste Lohnzeilen bei diesem Mitarbeitenden.',
  'pay.noFixedLinesRegistered': 'Es sind keine festen Zeilen erfasst.',
  'pay.internalDocumentationNote': 'Dies ist interne Dokumentation. Lohnläufe verwenden feste Lohnzeilen oder manuelle Zeilen in der Lohnauszahlung.',
  'pay.noAgreedSalaryBody': 'Gib einen Jahres- oder Stundenlohn ein, um die geschätzten Jahreskosten, Urlaubsgeld, Arbeitgeberabgabe und Steuer zu sehen.',
  'pay.selectOccupationCode': 'Berufscode wählen ...',
  'pay.noOccupationCodeMatch': 'Keine Treffer für „{query}“.',
  'pay.editEmployeeTitle': 'Mitarbeitenden bearbeiten',
  'pay.newEmployeeTitle': 'Neuer Mitarbeitender',
  'err.nativeValidation.payrollManualAMelding.1': 'Die manuelle Erfassung der A-melding erfordert eine norwegische Lohnabrechnung.',
  'err.nativeValidation.payrollManualAMelding.2': 'Die manuelle Einreichung muss ausdrücklich bestätigt werden.',
  'err.nativeValidation.payrollManualAMelding.3': 'Gültiger Meldezeitraum, Einreichungsdatum und manuelle Referenz müssen angegeben werden.',
  'err.nativeValidation.payrollManualAMelding.4': 'Das Einreichungsdatum muss nach dem Meldemonat liegen und darf nicht in der Zukunft liegen.',
  'err.nativeValidation.payrollManualAMelding.5': 'Bestätige genau die gebuchten Lohnläufe im Meldemonat.',
  'err.nativeValidation.payrollManualAMelding.6': 'Die manuelle Meldungsreferenz ist für diesen Monat bereits erfasst.',
  'err.nativeValidation.pensionPremiumMutation.1': 'Die Pensionszahlung erfordert eine norwegische Buchhaltung in NOK.',
  'err.nativeValidation.pensionPremiumMutation.2': 'Gültiger Pensionsbeleg und Datum müssen angegeben werden.',
  'err.nativeValidation.pensionPremiumMutation.3': 'Diese Pensionszahlung unterstützt nur die geprüften Sätze für 2026 in Zone I.',
  'err.nativeValidation.pensionPremiumMutation.4': 'Die Pensionszahlung verwendet das NOK-Bankkonto 1920.',
  'err.nativeValidation.pensionPremiumMutation.5': 'Pensionsbeträge müssen endliche, nicht negative Zahlen in ganzen Øre sein.',
  'err.nativeValidation.pensionPremiumMutation.6': 'Die Pensionszahlung kann nicht vor dem Buchungsdatum erfasst werden.',
  'err.nativeValidation.pensionPremiumMutation.7': 'Die Belegidentität für die Pension ist bereits reserviert.',
  'err.nativeValidation.pensionPremiumMutation.8': 'Die Nummerierungshistorie für Pensionen ist ungültig.',
});
